import React from 'react'
import { string } from 'prop-types'
import { encode } from 'base-64'

import { Content } from './styles' // styled component where we keep all the content styles
import { withRfqWidget } from '../RfqWidget'
import { withNatoms } from '../NatomsComponent'

ContentContainer.propTypes = {
	content: string.isRequired,
}

const createWebPUrl = (src, w, h) => {
	src = `http://www.business.com${src}`
	const resizerHost = 'https://img.business.com'

	// This regex plucks the last part of the src url
	// Example src: /images/content/5af/4720392a3a453198b456f/1430-883-
	// Regex would find: 1430-883-
	const cmsWidth = src.match(/([^/]+)\/?$/g)[0].split('-')[0]
	if (isNaN(cmsWidth)) {
		// force png at current WxH
		return `${resizerHost}/custom/of=png${w ? `,dw=${w}` : ''}${h ? `,dh=${h}` : ''}/${encode(src)}`
	}
	// Use cms' defined width to generate dyanmic image (serves webp if supported)
	return `${resizerHost}/w/${cmsWidth}/${encode(src)}`
}

const replaceFunctionDictionary = {
	src: (src) => createWebPUrl(src),
	srcset: (srcset = '') => {
		return srcset
			.split(', ')
			.map((src) => createWebPUrl(src))
			.join(', ')
	},
}
/**
 * This component just outputs dangerously set inner html and wrapped in a styled component with content styling
 *
 * Used for Article, Category and Review Templates
 */
function ContentContainer({ content }) {
	const newContent = content.replace(/(srcset|src)="(\/images(?:[^"]*))"/g, (matched, attribute, value, ...rest) => {
		const newValue = replaceFunctionDictionary[attribute](value)
		return `${attribute}="${newValue}"`
	})
	return <Content dangerouslySetInnerHTML={{ __html: newContent }} />
}

export default withRfqWidget(withNatoms(ContentContainer))
